import { orderBy } from "@progress/kendo-data-query";
import { getter } from "@progress/kendo-react-common";
import { Grid, GridColumn, GridNoRecords } from "@progress/kendo-react-grid";
import { Tooltip } from "@progress/kendo-react-tooltip";
import React, { useEffect, useState } from "react";
import { NotificationManager } from "src/util/notify";
import { useNavigate } from "react-router";
import Loader from "../../control-components/loader/loader";
import APP_ROUTES from "../../helper/app-routes";
import DropDownKendoRct from "../../control-components/drop-down/drop-down";
import { useSelector } from "react-redux";
import { staffPlanTemplateService } from "../../services/staffPlanTemplateService";
import { Chip } from "@progress/kendo-react-buttons";
import InputKendoRct from "../../control-components/input/input";
import AssignStaffTemplateToClinic from "./assign-staff-template-to-clinic";
import StaffDocumentTemplateInfo from "./staff-document-template-info";
import UpdateStaffTemplate from "./update-staff-template";
import AssignStaffTemplateLabel from "./staff-template-lable";
import CopyRegionInStaffTemplate from "./copy-region-in-staff-template";
import { Window } from "@progress/kendo-react-dialogs";

const DATA_ITEM_KEY = "id";
const SELECTED_FIELD = "selected";
const idGetter = getter(DATA_ITEM_KEY);
function StaffDocumentTemplate() {
  const regionData = useSelector((state) => state.getRegion);
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [page, setPage] = React.useState(0);
  const [pageSize, setPageSize] = React.useState(10);
  const [sort, setSort] = useState([]);
  const [selectedId, setSelectedId] = useState("");
  const [checkedTemplates, setCheckedTemplates] = useState([]);
  const [isAllSelected, setAllSelected] = useState(false);
  const [documentTemplateId, setDocumentTemplateId] = useState();
  const [defaultTemplates, setDefaultTemplates] = useState([]);
  const [copyRegionTemplate, setCopyRegionTemplate] = useState(false);
  const [assignTemplateSelectedId, setAssignTemplateSelectedId] = useState("");
  const [assignTemplateModule, setAssignTemplateModule] = useState(false);
  const [defaultTemplateList, setDefaultTemplateList] = useState([])
  const [searchText, setSearchText] = useState("")
  const [isAddTagOpen, setIsAddTagOpen] = useState(false)
  const [isEditTemplateOpen, setIsEditTemplateOpen] = useState(false)
  const [editSelectedData, setEditSelectedData] = useState()
  const [isOpenTemplateInfo, setIsOpenTemplateInfo] = useState(false)
  const [selectedTemplateInfo, setSelectedTemplateInfo] = useState()
  const [selectedState, setSelectedState] = React.useState({});
  const [fields, setFields] = useState({
    regionName: {},
    searchContent: ""
  });
  const [openedTemplateFile, setOpenedTemplateFile] = useState();
  const [loadingFileTemplate, setLoadingFileTemplate] = useState(false);
  const [clientBaseUrl, setClientBaseUrl] = useState('');


  useEffect(() => {
    let newObj = {
      id: regionData[0]?.id,
      regionName: regionData[0]?.regionName,
    };
    setFields({
      ...fields,
      regionName: newObj,
    });
  }, []);

  useEffect(() => {
    if (fields.regionName?.id) {
      getAllDefaultStaffDocumentTemplates(fields?.regionName);
    }
  }, [fields?.regionName?.id]);
  useEffect(() => {
    const currentUrl = window.location.href;
    const clientAppUrlPrefix = currentUrl.includes('admin.dev') ? "notenetic-ui." : "demo.";
    let updatedUrl = currentUrl.replace('admin.', clientAppUrlPrefix);
    updatedUrl = updatedUrl.replace(APP_ROUTES.STAFF_DOCUMENT_TEMPLATE, '');
    setClientBaseUrl(updatedUrl);
  }, []);



  const pageChange = (event) => {
    let skip = event.page.skip;
    let take = event.page.take;
    setPage(skip);
    setPageSize(take);
    setAllSelected(false)
  };

  const getAllDefaultStaffDocumentTemplates = async (value) => {
    setLoading(true);
    if (fields) {
      await staffPlanTemplateService
        .getAllDefaultStaffDocumentTemplates(fields?.regionName)
        .then((result) => {

          setDefaultTemplates(result?.resultData);
          setDefaultTemplateList(result?.resultData)
          setLoading(false);
        })
        .catch((error) => {
          setLoading(false);
          NotificationManager.error(error);
        });

    }
  };

  const handleAddDocumentTemplate = () => {
    navigate(APP_ROUTES.ADD_STAFF_DOCUMENT_TEMPLATE, { state: { fields } });
  };

  const handleChange = (e) => {
    setCheckedTemplates([]);
    const name = e.target.name;
    const value = e.target.value;
    setFields({
      ...fields,
      [name]: value,
    });
  };

  const handleCopyRegion = (field) => {
    setSelectedId(field);
    setCopyRegionTemplate(!copyRegionTemplate);
  };

  const handleAssignTemplateToClinic = (field) => {
    setAssignTemplateSelectedId(field);
    setAssignTemplateModule(!assignTemplateModule);
  };

  const handleAddTags = (field) => {
    setIsAddTagOpen(!isAddTagOpen)
    setDocumentTemplateId(field)
  }

  const handleFilter = (e) => {
    if (e.target.value === "") {
      setDefaultTemplates(defaultTemplateList)
    }
    else {
      const filterResult = (defaultTemplateList.filter((item) =>
      (item?.templateName?.toLowerCase().includes(e.target.value.toLowerCase())
        || item?.htmlFileName?.toLowerCase().includes(e.target.value.toLowerCase()))))
      setDefaultTemplates(filterResult)
      setPage(0)
    }
    setSearchText(e.target.value)
  }

  const onHeaderSelectionChange = React.useCallback((event) => {
    const checked = event.syntheticEvent.target.checked;
    setAllSelected(checked)
    let data = event.dataItems
    if (data.length > 0) {
      data.map(function (e) {
        return e.isSelected = false;
      });
      if (checked) {
        setCheckedTemplates(data)
      } else {
        setCheckedTemplates([])
      }
    }
  }, []);

  const handleEditTemplate = (field) => {
    setIsEditTemplateOpen(!isEditTemplateOpen)
    setEditSelectedData(field)
    setDocumentTemplateId(field?.id)

  }

  const handleSelectTemplateId = (field) => {
    setIsOpenTemplateInfo(!isOpenTemplateInfo)
    setSelectedTemplateInfo(field)
  }

  const onSelectionChange = (event) => {
    const item = event.dataItem;
    const isSelected = event.nativeEvent.target.checked;

    if (isSelected) {
      setCheckedTemplates((prev) => [...prev, item]);
    } else {
      setCheckedTemplates((prev) =>
        prev.filter((t) => t.id !== item.id)
      );
    }
  };

  function getFileViewClick(field) {
    return () => {
      setOpenedTemplateFile(field?.htmlFileName);
      setLoadingFileTemplate(true)
    };
  }

  return (
    <div >
      {openedTemplateFile && <Window
        title={`Template - ${openedTemplateFile}`}
        onClose={() => setOpenedTemplateFile(undefined)}
        initialHeight={window.innerHeight * 0.9}
        initialWidth={window.innerWidth * 0.9}
        height={window.innerHeight * 0.9}
        width={window.innerWidth * 0.9}
        style={{ overflow: 'hidden' }}
      >
        {loadingFileTemplate && <Loader />}
        <div style={{ width: '100%', height: '100%', overflow: 'hidden' }}>
          <iframe
            src={`${clientBaseUrl}/document/template/view?templateName=${openedTemplateFile}`}  // Replace with your URL
            style={{ width: '100%', height: '100%', border: 'none' }}
            title="Content"
            onLoad={() => {
              setLoadingFileTemplate(false);
            }}
          />
        </div>
      </Window>}
      <h4 className="address-title text-grey ">
        <span className="f-24">Staff Plan Template</span>
      </h4>
      <div className="d-flex flex-wrap justify-content-between align-items-center gap-2">
        <div className="col-lg-3 col-md-6 col-12 " style={{ paddingLeft: "0px", top: "10px" }}>
          <InputKendoRct
            value={searchText}
            onChange={handleFilter}
            name="searchContent"
            className="form-control"
            placeholder={" Search Template"}
          />
        </div>
        <div className="d-flex align-items-end">
          {
            checkedTemplates.length > 0 &&
            <button
              onClick={handleAddTags}
              className="green-btn  btn-primary mr-2"
            >
              Assign label
            </button>
          }

          <button
            onClick={handleAssignTemplateToClinic}
            className="green-btn  btn-primary mr-2"
          >
            Assign Template to Clinic
          </button>
          <button
            onClick={handleAddDocumentTemplate}
            className="green-btn  btn-primary"
          >
            <span class="k-icon k-font-icon k-i-plus" style={{ color: "#fff" }}></span> Add File Template
          </button>

          <div className="ml-3">
            <label className="form-label" style={{ fontSize: "1rem", position: "absolute", top: "90px" }}>
              Region
            </label>
            <DropDownKendoRct
              filterable={true}
              onChange={handleChange}
              data={regionData}
              value={fields.regionName}
              textField="regionName"
              name="regionName"
              dataItemKey="id"
              suggest={true}
            />
          </div>
        </div>
      </div>
      <div className="grid-table  filter-grid">
        <div className=" mt-3">
          <div className="inner-section-edit position-relative text-center">
            <div className="grid-table  filter-grid header-blue">
              <div className=" mt-3">
                {loading ? <Loader /> :
                  <Grid
                    style={{ height: '600px' }}
                    data={orderBy(
                      defaultTemplates?.slice(page, pageSize + page),
                      sort
                    ).map((item) => ({
                      ...item,
                      [SELECTED_FIELD]: selectedState[idGetter(item)],
                    }))}
                    checkboxElement
                    dataItemKey={DATA_ITEM_KEY}
                    selectedField={SELECTED_FIELD}
                    skip={page}
                    take={pageSize}
                    total={defaultTemplates?.length}
                    onPageChange={pageChange}
                    pageable={{
                      pageSizes: [10, 20, 30],
                    }}
                    sort={sort}
                    sortable={true}
                    onSortChange={(e) => {
                      setSort(e.sort);
                    }}
                    onHeaderSelectionChange={onHeaderSelectionChange}
                    selectable={{
                      enabled: true,
                      checkboxOnly: true,
                      mode: "multiple"
                    }}
                    onSelectionChange={onSelectionChange}
                  >
                    <GridNoRecords style={{}}></GridNoRecords>
                    <GridColumn
                      width="70px"
                      field={SELECTED_FIELD}
                      headerSelectionValue={isAllSelected}
                      columnType="checkbox"
                    />

                    <GridColumn
                      field="id"
                      width="150px"
                      title="Template ID"
                      cells={{
                        data: (props) => {
                          let field = props?.dataItem
                          return <td onClick={() => handleSelectTemplateId(field)} className="text-theme" style={{ cursor: "pointer" }}>{field?.id}</td>;
                        }
                      }}
                    />
                    <GridColumn
                      className="cursor-default"
                      field="templateName"
                      title="Template"
                      width="350px"
                      cells={{
                        data: (props) => {
                          let field = props?.dataItem
                          return <td className="cursor-default">{`${field?.templateName}`}</td>;
                        }
                      }}
                    />
                    <GridColumn
                      className="cursor-default"
                      field="htmlFileName"
                      title="File Name"
                      width="350px"
                      cells={{
                        data: (props) => {
                          let field = props?.dataItem
                          return <td className="cursor-default">{`${field?.htmlFileName}`}</td>;
                        }
                      }}
                    />

                    <GridColumn
                      className="cursor-default"
                      title="Template Label"
                      width="200px"
                      cells={{
                        data: (props) => {
                          let field = props?.dataItem
                          return (<td className="cursor-default">
                            {(field?.labelName && field.labelColor) ?
                              <Chip
                                text={field?.labelName}
                                key={field.id}
                                value="chip"
                                rounded={"large"}
                                fillMode={"solid"}
                                size={"medium"}
                                style={{
                                  marginRight: 5,
                                  backgroundColor: field.labelColor,
                                  marginBottom: 5,
                                  color: "#ffffff",
                                }}
                              /> : ""}
                          </td>)
                        }
                      }}
                    />
                    <GridColumn
                      title="Action"
                      width="200px"
                      filterable={false}
                      cells={{
                        data: (props) => {
                          let field = props.dataItem;
                          return (
                            <td>
                              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'start', gap: '8px', height: '100%' }}>
                                {
                                  <div
                                    className="k-chip k-chip-md k-rounded-md k-chip-solid k-chip-solid-base icon-red"
                                    style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}
                                    onClick={() => handleCopyRegion(field)}
                                  >
                                    <div className="k-chip-content">
                                      <Tooltip anchorElement="target" position="top">
                                        <i
                                          className="fa fa-clone"
                                          aria-hidden="true"
                                          title="Copy to Another Region"
                                        ></i>
                                      </Tooltip>
                                    </div>
                                  </div>
                                }
                                <div
                                  className="k-chip k-chip-md k-rounded-md k-chip-solid k-chip-solid-base icon-green"
                                  style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}
                                  onClick={() => handleEditTemplate(field)
                                  }
                                >
                                  <div className="k-chip-content">
                                    <Tooltip anchorElement="target" position="top">
                                      <i
                                        className="fa fa-edit"
                                        aria-hidden="true"
                                        title="Edit"
                                      ></i>
                                    </Tooltip>
                                  </div>
                                </div>
                                {field?.htmlFileName && (
                                  <div
                                    className="k-chip k-chip-md k-rounded-md k-chip-solid k-chip-solid-base icon-blue"
                                    style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}
                                    onClick={getFileViewClick(field)}
                                  >
                                    <div className="k-chip-content">
                                      <Tooltip anchorElement="target" position="top">
                                        <i
                                          className="fa-regular fa-eye"
                                          aria-hidden="true"
                                          title="View"
                                        ></i>
                                      </Tooltip>
                                    </div>
                                  </div>
                                )}
                                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                  <Chip
                                    text="Label"
                                    value="chip"
                                    icon={"fa fa-plus"}
                                    rounded={"large"}
                                    fillMode={"solid"}
                                    size={"medium"}
                                    onClick={() => handleAddTags(field)}
                                    style={{
                                      color: '#1a73e8',
                                      borderColor: '#1a73e8',
                                      backgroundColor: '#fff',
                                      fontWeight: 500,
                                      cursor: 'pointer',
                                      display: 'flex',
                                      alignItems: 'center',
                                      justifyContent: 'center',
                                      padding: '0 3px',
                                      height: '28px',
                                      fontSize: '13px'
                                    }}
                                  />
                                </div>
                              </div>
                            </td>
                          );
                        }
                      }}
                    />
                  </Grid>
                }
              </div>
            </div>
          </div>
        </div>
      </div>
      {isAddTagOpen && (
        <AssignStaffTemplateLabel
          onClose={handleAddTags}
          documentTemplateId={documentTemplateId}
          regionId={fields.regionName?.id}
          getAllDefaultStaffDocumentTemplates={getAllDefaultStaffDocumentTemplates}
          checkedTemplates={checkedTemplates}

        />
      )}
      {copyRegionTemplate && (
        <CopyRegionInStaffTemplate
          onClose={handleCopyRegion}
          documentTemplateId={selectedId}
          sourceRegionId={fields}
        />
      )}
      {assignTemplateModule && (
        <AssignStaffTemplateToClinic
          onClose={handleAssignTemplateToClinic}
          documentTemplateId={assignTemplateSelectedId}
          sourceRegionId={fields}
          checkedTemplates={checkedTemplates}
          getAllDefaultStaffDocumentTemplates={getAllDefaultStaffDocumentTemplates}

        />
      )}
      {isEditTemplateOpen && (
        <UpdateStaffTemplate
          onClose={handleEditTemplate}
          regionId={fields.regionName?.id}
          documentTemplateId={documentTemplateId}
          editSelectedData={editSelectedData}
          getAllDefaultStaffDocumentTemplates={getAllDefaultStaffDocumentTemplates}

        />
      )}
      {
        isOpenTemplateInfo && (
          <StaffDocumentTemplateInfo
            onClose={handleSelectTemplateId}
            selectedTemplateInfo={selectedTemplateInfo}
            regionId={fields.regionName?.id}
            getAllDefaultStaffDocumentTemplates={getAllDefaultStaffDocumentTemplates}

          />
        )
      }
    </div>
  );
}
export default StaffDocumentTemplate;
